import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { SnackbarProvider } from 'notistack';
import 'react-perfect-scrollbar/dist/css/styles.css';
import * as serviceWorker from './serviceWorker';
import { store, persistor } from './store';
import './styles/index.css';
import './styles/perfectScrollbarAdjustments.css';
import { initialiseI18next } from 'polygon-utils';
import resources from './constants/strings';
import HistoryRefSaver from './components/HistoryRefSaver';
import SnackbarRefSaver from './components/SnackbarRefSaver';
import App from './components/App';
import type { LangResource } from './libs/polygon-utils/src/utils/i18next';
import { RedcatAnalyticsProvider } from './analytics';

// this needs to be initialized ASAP
initialiseI18next(undefined, resources as LangResource);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <SnackbarProvider
        maxSnack={3}
        dense
        // This sets the css class of the generated component once a snackbar is used
        // snackbarrefsaver.tsx handles setting the css class's background colour programmatically
        classes={{
          variantSuccess: 'successSnackbar',
          variantWarning: 'warningSnackbar',
          variantError: 'errorSnackbar',
        }}
      >
        <SnackbarRefSaver />
        <RedcatAnalyticsProvider>
          <BrowserRouter basename={process.env.PUBLIC_URL}>
            <HistoryRefSaver />
            <App />
          </BrowserRouter>
        </RedcatAnalyticsProvider>
      </SnackbarProvider>
    </PersistGate>
    {/* </ErrorBoundary> */}
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
